import type { AirbrakeProject } from '@ui/lib/airbrake/config'

// Client-safe constants ONLY. This module is imported by
// instrumentation-client.ts (browser bundle) — it must never import
// @airbrake/node or any other server-only code.
//
// In-code env switch per AGENTS.md "Environment-conditional config":
// NEXT_PUBLIC_VERCEL_ENV is inlined at build time ('production' | 'preview' |
// undefined locally), so the falsy branch covers preview deploys AND local
// prod builds — both report to web-app-staging, keeping web-app-prod clean.
//
// Project keys are submission-only credentials (they ship in the public
// client bundle by design) — committing them is intended usage, not a leak:
// https://docs.airbrake.io/docs/devops-tools/api/
export const AIRBRAKE_PROJECT: AirbrakeProject =
  process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
    ? { projectId: 678190, projectKey: 'b327d73fbcaacfc47a8eff48727f8654' } // web-app-prod
    : { projectId: 678198, projectKey: '133afe604390eccf43326531e5b8367b' } // web-app-staging
